import { ExternalLink, Mail } from 'lucide-react'
import { Link } from 'react-router'
import { Container, Grid, HStack, VStack, styled } from '../../styled-system/jsx'

const FooterLink = styled(Link)

const linkStyles = {
    color: 'fg.muted',
    fontSize: 'sm',
    textDecoration: 'none',
    _hover: { color: 'fg.default' },
} as const

export function SiteFooter() {
    return (
        <styled.footer bg="bg.footer" borderTopWidth="1px" borderColor="border.subtle">
            <Container maxW="7xl" px={{ base: '4', md: '6' }} py={{ base: '8', md: '10' }}>
                <Grid gridTemplateColumns={{ base: '1fr', md: '2fr 1fr 1fr' }} gap={{ base: '8', md: '12' }}>
                    <VStack alignItems="start" gap="3" maxW="md">
                        <styled.img
                            src="/FINAL_entx_black.png"
                            alt="ENTX"
                            className="brand-logo-on-dark"
                            h="8"
                            w="auto"
                        />
                        <styled.p color="fg.muted" fontSize="sm">
                            Manage your venue presence, onboarding and ENTX services from one workspace.
                        </styled.p>
                    </VStack>

                    <VStack as="nav" aria-label="Venue partner links" alignItems="start" gap="2">
                        <styled.h2 fontSize="sm" fontWeight="semibold" mb="1">Venue partners</styled.h2>
                        <FooterLink to="/dashboard" {...linkStyles}>Dashboard</FooterLink>
                        <FooterLink to="/venues" {...linkStyles}>Venues</FooterLink>
                        <FooterLink to="/venues/start" {...linkStyles}>List your venue</FooterLink>
                        <FooterLink to="/login?intent=venue" {...linkStyles}>Sign in</FooterLink>
                    </VStack>

                    <VStack as="nav" aria-label="Support links" alignItems="start" gap="2">
                        <styled.h2 fontSize="sm" fontWeight="semibold" mb="1">Support</styled.h2>
                        <styled.a href="mailto:support@entx.io" display="flex" alignItems="center" gap="2" {...linkStyles}>
                            <Mail size={14} aria-hidden="true" />Contact support
                        </styled.a>
                        <styled.a href="https://entx.io" target="_blank" rel="noreferrer" display="flex" alignItems="center" gap="2" {...linkStyles}>
                            ENTX website<ExternalLink size={13} aria-hidden="true" />
                        </styled.a>
                    </VStack>
                </Grid>

                <HStack
                    mt="8"
                    pt="5"
                    borderTopWidth="1px"
                    borderColor="border.subtle"
                    justify="space-between"
                    gap="4"
                    flexWrap="wrap"
                    color="fg.subtle"
                    fontSize="xs"
                >
                    <styled.span>&copy; 2026 ENTX. Fair play all the way.</styled.span>
                    <HStack gap="4">
                        <styled.a href="https://entx.io/terms" target="_blank" rel="noreferrer" color="fg.subtle" _hover={{ color: 'fg.default' }}>Terms</styled.a>
                        <styled.a href="https://entx.io/privacy" target="_blank" rel="noreferrer" color="fg.subtle" _hover={{ color: 'fg.default' }}>Privacy</styled.a>
                    </HStack>
                </HStack>
            </Container>
        </styled.footer>
    )
}
